// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "contact-form-module--base-text-alt--global--74d2d";
export var baseTextGlobal = "contact-form-module--base-text--global--770df";
export var blockSpacing100 = "contact-form-module--block-spacing-100--fbab2";
export var blockSpacing50 = "contact-form-module--block-spacing-50--4e831";
export var blockVPadding100 = "contact-form-module--block-v-padding-100--214e0";
export var blockVPadding50 = "contact-form-module--block-v-padding-50--39521";
export var buttonContainer = "contact-form-module--buttonContainer--282df";
export var captionTextGlobal = "contact-form-module--caption-text--global--a5d6d";
export var checkBoxOption = "contact-form-module--checkBoxOption--0809e";
export var checkBoxes = "contact-form-module--checkBoxes--85206";
export var cmsRenderedContentGlobal = "contact-form-module--cms-rendered-content--global--225de";
export var container = "contact-form-module--container--8c026";
export var defaultHSpacingGlobal = "contact-form-module--default-h-spacing--global--7d7c2";
export var fadeInAnimation = "contact-form-module--fadeInAnimation--d28a5";
export var fadeInOnLoadGlobal = "contact-form-module--fade-in-on-load--global--12718";
export var form = "contact-form-module--form--dfb0d";
export var formField = "contact-form-module--formField--366c9";
export var formFieldsContainer = "contact-form-module--formFieldsContainer--ee74b";
export var formInput = "contact-form-module--formInput--abf4f";
export var formLabel = "contact-form-module--formLabel--e18a4";
export var fullHeightGlobal = "contact-form-module--full-height--global--ae800";
export var fullHeightOmittingNavGlobal = "contact-form-module--full-height-omitting-nav--global--5655c";
export var headingTextGlobal = "contact-form-module--heading-text--global--c9896";
export var ingressTextGlobal = "contact-form-module--ingress-text--global--b17ed";
export var linkColorChangeTransitionGlobal = "contact-form-module--link-color-change-transition--global--d3779";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "contact-form-module--page-heading-text--global--40f57";
export var paragraphTextGlobal = "contact-form-module--paragraph-text--global--58aea";
export var subheadingTextGlobal = "contact-form-module--subheading-text--global--9ebf3";
export var submitButton = "contact-form-module--submitButton--320f5";
export var textArea = "contact-form-module--textArea--436db";
export var title = "contact-form-module--title--a8319";